.group {
  border-radius: 5px;
  margin-top: 16px;
  margin-bottom: 4px;
  box-shadow: 1px 1px 4px rgb(45.6470588235%, 72.2745098039%, 88.4705882353%);
}
.group .header {
  border-radius: 5px;
  background-color: rgb(5.9705882353%, 19.7598039216%, 28.1470588235%);
  height: 32px;
  line-height: 32px;
  display: flex;
}
.group .header .name {
  padding-left: 12px;
  color: rgb(70.3970588235%, 84.8995098039%, 93.7205882353%);
  font-weight: bold;
  flex: 1 auto;
}
.group .buys .item {
  background-color: rgb(75.3470588235%, 87.4245098039%, 94.7705882353%);
  color: rgb(5.9705882353%, 19.7598039216%, 28.1470588235%);
  border-top: 1px solid rgb(86.8970588235%, 93.3161764706%, 97.2205882353%);
}
.group .buys .item:first-child {
  border-top: none;
}
.group .buys .item .ingredient {
  display: flex;
  align-items: center;
}
.group .buys .item .ingredient .buyButton {
  color: rgb(9.4705882353%, 31.3431372549%, 44.6470588235%);
  background-color: rgb(62.1470588235%, 80.6911764706%, 91.9705882353%);
  border-color: rgb(29.1470588235%, 63.8578431373%, 84.9705882353%);
  margin: 1px;
}
.group .buys .item .ingredient .ingredientName {
  flex: 0 1 auto;
  padding-left: 12px;
  font-size: 14px;
}
.group .buys .item .ingredient .amounts {
  flex: 1 1 auto;
  display: flex;
  justify-content: flex-start;
  margin-right: 4px;
  margin-left: 8px;
}
.group .buys .item .ingredient .amounts .amount {
  margin-right: 6px;
  font-size: 14px;
  line-height: 22px;
  background-color: #8e3f28;
  padding: 0px 6px;
  color: #f3c4b3;
  border-radius: 4px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.4);
}
.group .buys .item .ingredient .amounts .amount-group {
  margin: 0px 4px;
}
.group .buys .item .ingredient .buttons {
  flex: 0 0 auto;
  display: flex;
  margin-right: 12px;
}
.group .buys .item .ingredient .buttons .postponeButton {
  color: #207010;
}
.group .buys .item .ingredient .buttons .button {
  flex: 1 100%;
  margin-left: 4px;
}

:global(.dark) .group {
  box-shadow: 0px 0px 3px rgb(0.7205882353%, 2.3848039216%, 3.3970588235%);
  color: rgb(62.1470588235%, 80.6911764706%, 91.9705882353%);
}
:global(.dark) .group .header {
  background-color: rgb(7.7205882353%, 25.5514705882%, 36.3970588235%);
}
:global(.dark) .group .header .name {
  color: rgb(62.1470588235%, 80.6911764706%, 91.9705882353%);
}
:global(.dark) .group .buys .item {
  background-color: rgb(4.2205882353%, 13.9681372549%, 19.8970588235%);
  color: rgb(78.6470588235%, 89.1078431373%, 95.4705882353%);
  border-top: 1px solid rgb(5.9705882353%, 19.7598039216%, 28.1470588235%);
}
:global(.dark) .group .buys .item .ingredient .buyButton {
  color: rgb(29.1470588235%, 63.8578431373%, 84.9705882353%);
  background-color: rgb(2.4705882353%, 8.1764705882%, 11.6470588235%);
  border-color: rgb(9.4705882353%, 31.3431372549%, 44.6470588235%);
}
:global(.dark) .group .buys .item .buttons .postponeButton {
  color: #90c040;
}

.result {
  margin-right: 4px;
}

.unavailable {
  margin-top: 16px;
}
.unavailable .unavailableHeader {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 5px;
  background-color: rgba(128, 128, 128, 0.15);
  font-size: 0.85rem;
  cursor: pointer;
  user-select: none;
}

:global(.dark) .unavailable .unavailableHeader {
  color: #b8c6c2;
}

.ghosted {
  opacity: 0.5;
}

.base {
  perspective: 400px;
}

.appear, .enter {
  opacity: 0;
  transform: translate(0, 10px) rotateX(10deg);
  margin-bottom: -44px;
  transition: 0.5s ease-in-out;
}

.appearActive, .enterActive {
  opacity: 1;
  transform: translate(0, 0) rotateX(0);
  margin-bottom: 0px;
}

.enterDone {
  transform: none;
}

.exit {
  opacity: 1;
  transform: translate(0px, 0px) scale(1, 1) rotateX(0);
  transition: 0.3s ease-in-out;
}

.exitActive {
  opacity: 0;
  transform: translate(10px, 0px) scale(0.9, 0.9) rotateX(-10deg);
  margin-bottom: -44px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */